import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from '../'
// import { actionFetchStores } from '../../actions/stores'
// import './selectorStates.css'
import { AppDispatch, RootState } from '../../reducers/store'
import { actionFetchAdmins } from '../../actions/admins'
import { actionFetchContactMessages } from '../../actions/contactUs'


const CountMessagesSelector = () => {
    const dispatch                    = useDispatch<AppDispatch>();
    const { isLoading, totalNumber, currentPage }    = useSelector((state: RootState) => state.contactList)
    useEffect(() => {
      dispatch(actionFetchContactMessages({currentPage})); // You can pass the page number as needed
    }, [dispatch, currentPage]);
  return (
    <>
        { isLoading ? <Loader /> : (
            <>{totalNumber}</>
        )}
    </>
  )
}

export  {
  CountMessagesSelector,
}